module.exports = __webpack_public_path__ + "9207bed6b3d0b9e9b97e8005d171cb3b.png";